import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  variant = 'confirm',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  closeLabel = 'Close'
}) => {
  if (!isOpen) return null;
  const isInfoVariant = variant === 'info';

  return (
    <div className="confirmation-modal-overlay">
      <div className="confirmation-modal-content">
        <h3>{message}</h3>
        <div className="confirmation-modal-actions">
          {isInfoVariant ? (
            <button onClick={onClose} className="confirmation-confirm-button">
              {closeLabel}
            </button>
          ) : (
            <>
              <button onClick={onConfirm} className="confirmation-confirm-button" data-testid="confirmation-confirm">
                {confirmLabel}
              </button>
              <button onClick={onClose} className="confirmation-cancel-button">
                {cancelLabel}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;

